module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/62d5af41ef7f140cf3c9e5ccefd3fcdb.svg";